/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreAcceptQuoteRequest
 */
export interface PreAcceptQuoteRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof PreAcceptQuoteRequest
     */
    clientAdminAccountIds: Array<string>;
}

/**
 * Check if a given object implements the PreAcceptQuoteRequest interface.
 */
export function instanceOfPreAcceptQuoteRequest(value: object): value is PreAcceptQuoteRequest {
    if (!('clientAdminAccountIds' in value) || value['clientAdminAccountIds'] === undefined) return false;
    return true;
}

export function PreAcceptQuoteRequestFromJSON(json: any): PreAcceptQuoteRequest {
    return PreAcceptQuoteRequestFromJSONTyped(json, false);
}

export function PreAcceptQuoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreAcceptQuoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientAdminAccountIds': json['clientAdminAccountIds'],
    };
}

export function PreAcceptQuoteRequestToJSON(value?: PreAcceptQuoteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientAdminAccountIds': value['clientAdminAccountIds'],
    };
}

